import {getWorkspaceFromUri, urlBuilder} from '@dms/routes';

import type {Nullish} from 'shared/web';

import {createSearchParamsString} from './createSearchParamsString';

interface GetBuyingOnlineOfferUriParams {
  offerId: string | Nullish;
  language: string;
  sellerEmail: string | Nullish;
}

const {workspace} = getWorkspaceFromUri();

export function getBuyingOnlineOfferUri(params: GetBuyingOnlineOfferUriParams) {
  return urlBuilder({
    workspace,
    protocol: window.location.protocol,
    domain: process.env.ONLINE_OFFER_DOMAIN!,
    route: `/${params.offerId}/buying`,
    searchParam: createSearchParamsString({
      lang: params.language,
      sellerEmail: params.sellerEmail ?? undefined,
    }),
  });
}
